const ChequeKizGridPluginSettings: IPluginSettings = {
    name: 'КИЗ',
    mnemocode: 'cheque_kiz_plugin',
    permission: 'Cheque',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'IdGlobal',
            visibility: false,
            width: 150
        }, {
            order: 1,
            propertyName: 'gtin',
            propertyType: 'string',
            displayName: 'GTIN',
            visibility: true,
            width: 150
        }, {
            order: 2,
            propertyName: 'kiz',
            propertyType: 'string',
            displayName: 'Киз',
            visibility: true,
            width: 150
        }, {
            order: 3,
            propertyName: 'sGtin',
            propertyType: 'string',
            displayName: 'SGTIN',
            visibility: true,
            width: 150
        }, {
            order: 4,
            propertyName: 'kizState',
            propertyType: 'string',
            displayName: 'Статус КИЗ',
            visibility: true,
            width: 150
        }, {
            order: 5,
            propertyName: 'docType',
            propertyType: 'string',
            displayName: 'Схема',
            visibility: true,
            width: 150
        }, {
            order: 6,
            propertyName: 'idError',
            propertyType: 'string',
            displayName: 'Код Ошибки',
            visibility: true,
            width: 150
        }, {
            order: 7,
            propertyName: 'error',
            propertyType: 'string',
            displayName: 'Ошибка ГИС "Маркировка"',
            visibility: true,
            width: 150
        }, {
            order: 8,
            propertyName: 'decodedBarcode',
            propertyType: 'string',
            displayName: 'КИЗ',
            visibility: true,
            width: 150
        }, {
            order: 9,
            propertyName: 'gtinSGtin',
            propertyType: 'string',
            displayName: 'GTIN_SGTIN',
            visibility: true,
            width: 150
        }
    ]
}
export default ChequeKizGridPluginSettings